__turbopack_context__.v({
  "heading": "StockLevelModal-module-scss-module__f-AkZG__heading",
  "logoWrapper": "StockLevelModal-module-scss-module__f-AkZG__logoWrapper",
  "modal": "StockLevelModal-module-scss-module__f-AkZG__modal",
  "modalContainer": "StockLevelModal-module-scss-module__f-AkZG__modalContainer",
  "stockDetails": "StockLevelModal-module-scss-module__f-AkZG__stockDetails",
  "storeWrapper": "StockLevelModal-module-scss-module__f-AkZG__storeWrapper",
});
